import * as constants from "./constants";

const initialState = {
  statusOptions: [],
  allProjects: [],
  currentProjectObj: {},
  utilsData: {},
  updateNotLoading: false,
  departmentsList: [],
  createProjectLoading: false,
  projectDetailsIsEdit: false,
  fetchProjectsLoading: false,
  deleteProjectLoading: false,
  fetchProjectDetailLoading: false,
  totalRecords: 0,
  deleteAttachLoading: false,
  projectNotificationIsEdit: false,
};

const projectsSetupReducer = (state = initialState, action) => {
  switch (action.type) {
    case constants.FETCH_PROJECTS_UTIL_DATA_SUCCESS:
      // const { sales_reps } = action.data;
      return {
        ...state,
        utilsData: {
          ...action.data,
        },
      };
    case constants.PROJECT_DETAILS_IS_EDIT:
      return {
        ...state,
        projectDetailsIsEdit: action.data,
      };

    case constants.CREATE_PROJECT:
      return {
        ...state,
        createProjectLoading: true,
      };
    case constants.CREATE_PROJECT_SUCCESS:
      return {
        ...state,
        createProjectLoading: false,
        currentProjectObj: action.data,
        projectDetailsIsEdit: false,
      };
    case constants.CREATE_PROJECT_ERROR:
      return {
        ...state,
        createProjectLoading: false,
      };
    case constants.UPDATE_PROJECT:
      return {
        ...state,
        createProjectLoading: true,
      };
    case constants.UPDATE_PROJECT_SUCCESS:
      return {
        ...state,
        createProjectLoading: false,
        currentProjectObj: action.data,
        projectDetailsIsEdit: false,
      };
    case constants.UPDATE_PROJECT_ERROR:
      return {
        ...state,
        createProjectLoading: false,
      };

    case constants.UPDATE_PROJECT_NOTIFICATION:
      return {
        ...state,
        updateNotLoading: true,
      };
    case constants.UPDATE_PROJECT_NOTIFICATION_SUCCESS:
      return {
        ...state,
        updateNotLoading: false,
        projectNotificationIsEdit: false,
      };
    case constants.UPDATE_PROJECT_NOTIFICATION_ERROR:
      return {
        ...state,
        updateNotLoading: false,
      };

    case constants.FETCH_ALL_PROJECTS:
      return {
        ...state,
        fetchProjectsLoading: true,
      };
    case constants.FETCH_ALL_PROJECTS_SUCCESS:
      const { total_projects, projects } = action.data;
      return {
        ...state,
        allProjects: projects,
        fetchProjectsLoading: false,
        totalRecords: total_projects,
      };
    case constants.FETCH_ALL_PROJECTS_ERROR:
      return {
        ...state,
        fetchProjectsLoading: false,
      };
    case constants.DELETE_PROJECT:
      return {
        ...state,
        deleteProjectLoading: true,
      };
    case constants.DELETE_PROJECT_SUCCESS:
      let updatedProjects = state.allProjects.filter(
        (el) => el.id !== action.data.id
      );
      let totalRecords = state.totalRecords - 1;
      let lselectedProjects = JSON.parse(
        localStorage.getItem("lsselectedProjects")
      );

      if (lselectedProjects?.length > 0) {
        let lisCheck = JSON.parse(localStorage.getItem("lsisCheck"));
        let llist = JSON.parse(localStorage.getItem("lslist"));
        let lfilteredProjects = JSON.parse(
          localStorage.getItem("lsfilteredProjects")
        );
        let updatedlsselectedProjects = lselectedProjects.filter(
          (project) => project.id !== action.data.id
        );

        if (updatedlsselectedProjects.length > 0) {
          localStorage.setItem(
            "lsselectedProjects",
            JSON.stringify(updatedlsselectedProjects)
          );

          if (lselectedProjects !== null) {
            let userPojectsIds = updatedProjects.map((el) => el.id);

            let updatedLsfilteredProjects = lfilteredProjects.filter((el) =>
              userPojectsIds.includes(el.id)
            );

            let updatedlsisCheck = lisCheck.filter((id) =>
              userPojectsIds.includes(id)
            );
            let updatedlslist = llist.filter((el) =>
              userPojectsIds.includes(el.id)
            );

            localStorage.setItem(
              "lsselectedProjects",
              JSON.stringify(updatedlsselectedProjects)
            );
            localStorage.setItem(
              "lsfilteredProjects",
              JSON.stringify(updatedLsfilteredProjects)
            );

            localStorage.setItem("lsisCheck", JSON.stringify(updatedlsisCheck));
            localStorage.setItem("lslist", JSON.stringify(updatedlslist));
          }
        } else {
          localStorage.removeItem("lsselectedProjects");
          localStorage.removeItem("lsfilteredProjects");
          localStorage.removeItem("lsisCheck");
          localStorage.removeItem("lslist");
        }
      }

      return {
        ...state,
        totalRecords: totalRecords,
        deleteProjectLoading: false,
        allProjects: updatedProjects,
      };
    case constants.DELETE_PROJECT_ERROR:
      return {
        ...state,
        deleteProjectLoading: false,
      };

    case constants.DELETE_PROJECT_ATTACH:
      return {
        ...state,
        deleteAttachLoading: true,
      };
    case constants.DELETE_PROJECT_ATTACH_SUCCESS:
      const { id } = action.data;

      let updatedDocs = state.currentProjectObj.document_urls.filter(
        (el) => el.id != id
      );

      return {
        ...state,
        deleteAttachLoading: false,
        currentProjectObj: {
          ...state.currentProjectObj,
          document_urls: updatedDocs,
        },
      };
    case constants.DELETE_PROJECT_ATTACH_ERROR:
      return {
        ...state,
        deleteAttachLoading: false,
      };

    case constants.FETCH_PROJECT:
      return {
        ...state,
        // departmentLoading: true,
        fetchProjectDetailLoading: true,
      };
    case constants.FETCH_PROJECT_SUCCESS:
      return {
        ...state,
        currentProjectObj: action.data,
        fetchProjectDetailLoading: false,
      };
    case constants.FETCH_PROJECT_ERROR:
      return {
        ...state,
        fetchProjectDetailLoading: false,
      };

    case constants.PROJECT_NOTIF_IS_EDIT:
      return {
        ...state,
        projectNotificationIsEdit: action.data,
      };

    case constants.PROJECT_DETAIL_CLEANUP_FUNC:
      return {
        ...state,
        allProjects: [],
        createProjectLoading: false,
        currentProjectObj: {},
        projectDetailsIsEdit: false,
        fetchProjectsLoading: false,
        deleteProjectLoading: false,
        projectNotificationIsEdit: false,
      };
    default:
      return state;
  }
};

export default projectsSetupReducer;
